// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const AuratypesSoftwareSensitivity = {
  SoftwareSensitivityRestricted: 'restricted',
  SoftwareSensitivityConfidential: 'confidential',
  SoftwareSensitivityInternal: 'internal',
  SoftwareSensitivityPublic: 'public',
  SoftwareSensitivityUnspecified: 'unspecified',
} as const;
export type AuratypesSoftwareSensitivity =
  (typeof AuratypesSoftwareSensitivity)[keyof typeof AuratypesSoftwareSensitivity];

export function instanceOfAuratypesSoftwareSensitivity(value: any): boolean {
  for (const key in AuratypesSoftwareSensitivity) {
    if (
      Object.prototype.hasOwnProperty.call(AuratypesSoftwareSensitivity, key)
    ) {
      if (
        AuratypesSoftwareSensitivity[
          key as keyof typeof AuratypesSoftwareSensitivity
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function AuratypesSoftwareSensitivityFromJSON(
  json: any,
): AuratypesSoftwareSensitivity {
  return AuratypesSoftwareSensitivityFromJSONTyped(json, false);
}

export function AuratypesSoftwareSensitivityFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AuratypesSoftwareSensitivity {
  return json as AuratypesSoftwareSensitivity;
}

export function AuratypesSoftwareSensitivityToJSON(
  value?: AuratypesSoftwareSensitivity | null,
): any {
  return value as any;
}

export function AuratypesSoftwareSensitivityToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): AuratypesSoftwareSensitivity {
  return value as AuratypesSoftwareSensitivity;
}
